var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02425 4.40407C7.24711 4.62693 7.60882 4.62693 7.83254 4.40407C8.05625 4.18121 8.05539 3.8195 7.83254 3.59579L7.02425 4.40407ZM3.99941 0.570944L4.40312 0.167232C4.18027 -0.0556245 3.81855 -0.0556245 3.59484 0.167232L3.99941 0.570944ZM0.167142 3.59579C-0.0557137 3.81864 -0.0557137 4.18036 0.167142 4.40407C0.389998 4.62778 0.751711 4.62693 0.975424 4.40407L0.167142 3.59579ZM7.83254 3.59579L4.40312 0.167232L3.5957 0.975513L7.02425 4.40407L7.83254 3.59579ZM3.5957 0.167232L0.167142 3.59579L0.975424 4.40407L4.40398 0.975513L3.5957 0.167232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorup);
export default __webpack_public_path__ + "static/media/Vector up.2b0a67b506cfd8a60b21e940744ec29b.svg";
export { ForwardRef as ReactComponent };